import React from 'react';
import AuthStore from '../Auth/store/AuthStore';
import {SessionContextType} from '../session.types';

const getContextStores = (): SessionContextType => {
  const store = new AuthStore();
  return {
    store,
  };
};
export const ContextSessionStores = React.createContext<SessionContextType>(getContextStores());
